import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';;
import PageLoader from '../../../../components/PageLoader';
import GlobalRegistriesComponent from '../components/open-network-registries.component';
import { selectOpenNetworkRegistrationsQueryItems } from '../../../../redux/open-network-registrations/selector';
import { openNetworkRegistrations } from '../../../../redux/open-network-registrations/action';


const OpenNetworkRegistration = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const dbnpRegistriesQuery = useSelector(selectOpenNetworkRegistrationsQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [ selectedOpenNetworkRegistry, setSelectedOpenNetworkRegistry ] = useState<any>({})

    const fetchOpenNetworkRegistryById = () => {
        dispatch(openNetworkRegistrations.query({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/query`, 
            entity: 'openNetworkRegistrations', 
            jsonData: {
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleBacicInnerFormChange: any = (event: any, field: string) => {
        setSelectedOpenNetworkRegistry({ ...selectedOpenNetworkRegistry, [field]: event });
    }
    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
          '.',
          field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedOpenNetworkRegistry({ ...selectedOpenNetworkRegistry, [fields[0]]: value });
    }

    useEffect(
        () => {
                if (parmas?.id > 0) {
                    fetchOpenNetworkRegistryById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            
        },
        []
    )

    // const parentDomain = openNetworkDomainNameLists?.result?.items.filter(
    //     (subDomainData: any) => subDomainData.IsSubDomain === false
    // )
    // const subDomains = openNetworkDomainNameLists?.result?.items.filter(
    //     (subDomainData: any) => subDomainData.IsSubDomain === true
    // )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedOpenNetworkRegistry(dbnpRegistriesQuery?.result?.items)
            }
        },
        [isQuery]
    )

    // const handleFormSubmit = async (event: any) => {
    //     event.preventDefault();
    //     if (parmas?.id > 0) {
    //         dispatch(globalOrgRegistrations.update({
    //             url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations`, 
    //             entity: 'globalOrgRegistrations', 
    //             jsonData: {
    //                 Records: [
    //                     selectedDbnpRegistry
    //                 ]
    //             }
    //         })).then(() => {
    //             back()
    //         })
    //     } else {
    //         dispatch(globalOrgRegistrations.create({
    //             url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations`, 
    //             entity: 'globalOrgRegistrations', 
    //             jsonData: {
    //                 Records: [
    //                     selectedDbnpRegistry
    //                 ]
    //             }
    //         })).then(() => {
    //             back()
    //         })
    //     }
    // }

    const back = () => {
        navigate('/dbn/open-network-registrations')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <GlobalRegistriesComponent
                    handleInnerFormChange={handleInnerFormChange}
                    handleBacicInnerFormChange={handleBacicInnerFormChange}
                    selectedDbnpRegistry={selectedOpenNetworkRegistry}
                    back={back}
                    id={parmas?.id}
                />
            }
        </>
    )

}

export default OpenNetworkRegistration;